import { render, staticRenderFns } from "./DDSCard.vue?vue&type=template&id=7e742261&scoped=true"
import script from "./DDSCard.vue?vue&type=script&lang=js"
export * from "./DDSCard.vue?vue&type=script&lang=js"
import style0 from "./DDSCard.vue?vue&type=style&index=0&id=7e742261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e742261",
  null
  
)

export default component.exports